if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const mediaId = this.openedBy.getAttribute('data-media-id');
        const container = this.querySelector('[role="document"]');
        if (!container) return;

        // On mobile, CSS hides .product-media-modal__content > *:not(.active), so we must add
        // .active to the direct child (picture / deferred-media / div), not the inner img.
        container.querySelectorAll(':scope > .active').forEach((el) => el.classList.remove('active'));

        const activeMedia = this.querySelector(`[data-media-id="${mediaId}"]`);
        if (!activeMedia) return;

        let wrapper = activeMedia;
        while (wrapper.parentElement && wrapper.parentElement !== container) {
          wrapper = wrapper.parentElement;
        }
        wrapper.classList.add('active');

        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        wrapper.scrollIntoView();

        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName === 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        ) {
          activeMedia.loadContent();
        }
      }
    }
  );
}
